/* ==========================================================================
   LYSORIC COLLECTION JS
   ========================================================================== */

window.LysoricCollection = (function () {

  var WISHLIST_KEY = 'lysoric_wishlist';

  function getWishlist() {
    try {
      return new Set(
        JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]')
      );
    } catch(e){
      return new Set();
    }
  }

  function saveWishlist(set){
    localStorage.setItem(
      WISHLIST_KEY,
      JSON.stringify(Array.from(set))
    );
  }

  /* =====================================
     UPDATE HEADER CART COUNT
  ===================================== */

  function updateCartCount(){
    fetch('/cart.js')
    .then(function(response){
      return response.json();
    })
    .then(function(cart){
      document.querySelectorAll('.cart-badge')
      .forEach(function(badge){
        badge.textContent = cart.item_count;
        if(cart.item_count > 0){
          badge.style.display = "inline-flex";
        }else{
          badge.style.display = "none";
        }
      });
    })
    .catch(function(error){
      console.log("Cart count update error:", error);
    });
  }

  /* =====================================
     UPDATE HEADER WISHLIST COUNT
  ===================================== */

  function updateWishlistCount(){
    var wishlist = getWishlist();
    document.querySelectorAll('.wishlist-count').forEach(function(badge){
      badge.textContent = wishlist.size;
    });
  }

  function init(sectionId, options){

    var root = document.getElementById(
      'lc-' + sectionId
    );

    if(!root || root.dataset.lcInit) return;

    root.dataset.lcInit='1';

    options = options || {};

    var collectionTitle =
      options.collectionTitle || 'bags';

    var grid =
      document.getElementById(
        'lc-grid-' + sectionId
      );

    var emptyState =
      document.getElementById(
        'lc-empty-' + sectionId
      );

    var countEl =
      document.getElementById(
        'lc-count-' + sectionId
      );

    var searchInput =
      document.getElementById(
        'lc-search-' + sectionId
      );

    var clearBtn =
      document.getElementById(
        'lc-clear-' + sectionId
      );

    var sortBtn =
      document.getElementById(
        'lc-sort-btn-' + sectionId
      );

    var sortMenu =
      document.getElementById(
        'lc-sort-menu-' + sectionId
      );

    var wishlist = getWishlist();

    var activeFilter='all';

    var query='';

    /* =====================================
       WISHLIST
    ===================================== */

    root.querySelectorAll('.lc-heart')
    .forEach(function(btn){

      var id = btn.dataset.id;

      if(wishlist.has(id)){
        btn.classList.add('is-saved');
      }

      btn.addEventListener(
        'click',
        function(e){
          e.preventDefault();
          e.stopPropagation();

          if(wishlist.has(id)){
            wishlist.delete(id);
            btn.classList.remove('is-saved');
          }else{
            wishlist.add(id);
            btn.classList.add('is-saved');
          }

          saveWishlist(wishlist);
          updateWishlistCount();
        }
      );

    });

    // Page load par bhi header badge sahi dikhaye
    updateWishlistCount();

    /* =====================================
       QUICK ADD TO CART
    ===================================== */

    root.querySelectorAll('.lc-quickadd')
    .forEach(function(btn){

      btn.addEventListener(
        'click',
        function(e){
          e.preventDefault();
          e.stopPropagation();

          var variantId =
            btn.dataset.variantId;

          if(!variantId) return;

          btn.disabled=true;

          fetch('/cart/add.js',{
            method:'POST',
            headers:{
              'Content-Type':'application/json',
              'Accept':'application/json'
            },
            body:JSON.stringify({
              items:[
                {
                  id:variantId,
                  quantity:1
                }
              ]
            })
          })
          .then(function(response){
            return response.json();
          })
          .then(function(data){
            console.log(
              'Cart Added',
              data
            );

            btn.classList.add('added');
            btn.innerHTML='✓';

            updateCartCount();

            setTimeout(function(){
              btn.classList.remove('added');
              btn.disabled=false;

              btn.innerHTML = `
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
              `;
            },1500);
          })
          .catch(function(error){
            console.error(
              'Lysoric quick add failed:',
              error
            );
            btn.disabled=false;
          });
        }
      );

    });

    /* =====================================
       SEARCH
    ===================================== */

    function applyFilters(){

      if(!grid) return;

      var cards =
        grid.querySelectorAll('.lc-card');

      var visibleCount=0;

      cards.forEach(function(card){

        var matchesQuery =
          !query ||
          card.dataset.name.indexOf(query)!==-1;

        card.style.display =
          matchesQuery ? '' : 'none';

        if(matchesQuery){
          visibleCount++;
        }

      });

      if(countEl){
        countEl.innerHTML =
        'Showing <b>' +
        visibleCount +
        '</b> ' +
        collectionTitle;
      }

      if(emptyState){
        emptyState.style.display =
          visibleCount===0 ? 'flex':'none';
      }

    }

    if(searchInput){
      searchInput.addEventListener(
        'input',
        function(){
          query =
          searchInput.value
          .trim()
          .toLowerCase();

          applyFilters();
        }
      );
    }

    if(clearBtn){
      clearBtn.addEventListener(
        'click',
        function(){
          query='';
          searchInput.value='';
          applyFilters();
        }
      );
    }

    /* SORT MENU */

    if(sortBtn && sortMenu){
      sortBtn.addEventListener(
        'click',
        function(e){
          e.stopPropagation();
          sortMenu.classList.toggle('open');
        }
      );
    }

  }

  return {
    init:init
  };

})();